module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./../node_modules/babel-loader/index.js!./notes.js"));
	});
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/bundle-loader?lazy!./src/notes.js
 ** module id = 1
 ** module chunks = 2
 **/